import request from '@/router/axios'
import env from '@/config/env'
import ar from "element-ui/src/locale/lang/ar";

/**
 * 保存
 * @param data
 */
export const save = (data) => {
  return request({
    url: env.ferryUrl + '/serviceArea/save',
    method: 'POST',
    data: data
  })
}

/**
 * 编辑
 * @param data
 */
export const update = (data) => {
  return request({
    url: env.ferryUrl + '/serviceArea/update',
    method: 'PUT',
    data: data
  })
}

/**
 * 获取服务区域列表
 * @param data
 */
export const list = (data) => {
  return request({
    url: env.ferryUrl + '/serviceArea/list',
    method: 'POST',
    data: data
  })
}

/**
 * 删除
 * @param areaCoverageNo
 */
export const deleted = (areaCoverageNo) => {
  return request({
    url: env.ferryUrl + `/serviceArea/delete/${areaCoverageNo}`,
    method: 'DELETE'
  })
}

/**
 * 获取详情
 * @param areaCoverageNo
 */
export const getInfo = (areaCoverageNo) => {
  return request({
    url: env.ferryUrl + `/serviceArea/selectByAreaCoverageNo/${areaCoverageNo}`,
    method: 'POST'
  })
}

export const copyService = (areaCoverageNo) => {
  return request({
    url: env.ferryUrl + `/serviceArea/copyAreaCoverage/${areaCoverageNo}`,
    method: 'post',
  })
}



